import React from 'react';
import { useIntl } from 'umi';
import ReusePageTemplate from '@intelligence/v3/components/ReusePageTemplate';
import CasualCompetitors from '@home/pages/studio/casualHub/CasualCompetitors';
import MarqueeBanner from '@intelligence/components/MarqueeBanner/index';
import { LANGUAGE_CN } from '@home/_config/config';
import {
  BRIDGE_STUDIO_INFO,
  DBI_CATEGORY_KPI_TIPS_I18N,
  DBI_KEY_GAMES_TABLE_TIPS_I18N,
  DBI_TOP_PUBLISHERS_KPI_TIPS_I18N,
  DBI_TOP_PUBLISHERS_TABLE_TIPS_I18N,
} from './config';

import './index.scss';

const BRIDGE_DEFAULT_COMPETITORS_GENRE = { primaryTab: 'general_casual' };

const CasualHubCompetitorsBridge: React.FC = () => {
  const { locale } = useIntl();
  const isCn = locale === LANGUAGE_CN;
  const { studio_dashboard_list: dashboardList = [] } = BRIDGE_STUDIO_INFO.data;
  const competitorsDashboard = dashboardList.find((item) => item.path === '/competitors');
  const title = (isCn ? competitorsDashboard?.name_cn : competitorsDashboard?.name_en) ?? '';

  return (
    <ReusePageTemplate className="dbi-casual-hub-competitors-bridge" title={title}>
      <MarqueeBanner className="dbi-casual-hub-marquee" />
      <CasualCompetitors
        showRevenueScopeSwitcher
        showFilterTipsText={false}
        studioInfo={BRIDGE_STUDIO_INFO}
        categoryKpiTipsI18n={DBI_CATEGORY_KPI_TIPS_I18N}
        keyGamesTableTipsI18n={DBI_KEY_GAMES_TABLE_TIPS_I18N}
        topPublisersKpiTipsI18n={DBI_TOP_PUBLISHERS_KPI_TIPS_I18N}
        topPublishersTableTipsI18n={DBI_TOP_PUBLISHERS_TABLE_TIPS_I18N}
        defaultCompetitorsGenre={BRIDGE_DEFAULT_COMPETITORS_GENRE}
      />
    </ReusePageTemplate>
  );
};

export default CasualHubCompetitorsBridge;
